<template>
  <div class="record-chart">
    <div class="record-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="pledgeTableRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        @edit-closed="editClosedEvent"
        :edit-disabled="false"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @edit-actived="editActivedEvent"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
        :footer-method="footerMethod"
        show-footer
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
        <template v-slot:buttons>
          <el-button size="small" type="primary" class="vxe-btn-primary"
            >质押物明细行信息</el-button
          >
          <template v-if="showTableBtn">
            <el-button
              @click="$refs.pledgeTableRef.commitProxy('insert_actived')"
              size="small"
              type="primary"
              class="vxe-btn-primary"
              >新增</el-button
            >
            <el-button @click="deleteRowHandler" size="small" type="danger" class="vxe-btn-delete"
              >删除</el-button
            >
          </template>
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'goodsType'">{{
              getName('goodsType', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'goodsCategory'">{{
              getName('goodsCategory', row[item.field])
            }}</span>
            <!-- <span v-else-if="item.field == 'goodsModelId'">{{
              getName('goodsModelId', row['goodsModel'])
            }}</span>
            <span v-else-if="item.field == 'goodsPlaceId'">{{
              getName('goodsPlaceId', row['goodsPlace'])
            }}</span>
            <span v-else-if="item.field == 'packId'">{{ getName('packId', row['pack']) }}</span> -->
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <search-table
              v-if="item.editRender.name == 'goodsType'"
              ref="searchTable"
              v-model="row.goodsType"
              searchType="product"
              :isMultiple="true"
              :currentValue="getName('goodsType', row.goodsType)"
              :checkRowKeys="[row.goodsType] || []"
              :extraData="{
                parentProductStatus: 'ZT03',
                selectCompanyCode: userInfo.companyCode,
                adminFlag: userInfo.adminFlag,
              }"
              @input="(val) => changeCargoTypeHandler(row, val)"
            ></search-table>
            <!-- <el-select
              v-if="item.editRender.name == 'goodsType'"
              filterable
              clearable
              :disabled="isDisabled"
              v-model="row[item.field]"
              @change="(val) => goodsTypeChange(row, val)"
            >
              <el-option
                v-for="(i, index) in goodsTypeList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select> -->
            <!-- <el-select
              v-else-if="item.editRender.name == 'goodsCategory'"
              filterable
              clearable
              :disabled="isDisabled"
              v-model="row[item.field]"
            >
              <el-option
                v-for="(i, index) in goodsCategoryList"
                :key="index"
                :label="i.label"
                :value="i.value"
              ></el-option>
            </el-select> -->
            <search-table
              v-else-if="item.editRender.name == 'goodsCategory'"
              ref="searchTable"
              v-model="row.goodsCategory"
              searchType="goodsDetail"
              :isMultiple="true"
              :currentValue="getName('goodsCategory', row.goodsCategory)"
              :checkRowKeys="[row.goodsCategory] || []"
              :extraData="{
                parentProductStatus: 'ZT03',
                productParentCodes: [row.goodsType],
              }"
              @input="(val) => changeCargoCategoryHandler(row, val)"
            ></search-table>
            <el-select
              v-else-if="item.editRender.name == 'unit'"
              filterable
              clearable
              :disabled="isDisabled"
              v-model="row[item.field]"
            >
              <el-option value="个" label="个"></el-option>
              <el-option value="件" label="件"></el-option>
              <el-option value="吨" label="吨"></el-option>
              <el-option value="卷" label="卷"></el-option>
            </el-select>
            <el-select
              v-else-if="item.editRender.name == 'measureMethod'"
              filterable
              clearable
              :disabled="isDisabled"
              v-model="row[item.field]"
            >
              <el-option value="重量" label="重量"></el-option>
              <el-option value="数量" label="数量"></el-option>
            </el-select>
            <el-input
              v-else-if="item.editRender.name == 'input'"
              :disabled="isDisabled"
              v-model="row[item.field]"
            >
            </el-input>
            <el-input-number
              :precision="2"
              :min="null"
              :disabled="isDisabled"
              :controls="false"
              v-else-if="item.editRender.name == 'quantity'"
              v-model="row[item.field]"
              @change="handleChangeQuantity"
            ></el-input-number>
            <el-input-number
              :precision="2"
              :disabled="isDisabled"
              :controls="false"
              :min="-9999999999999"
              :max="99999999999999"
              v-else-if="item.editRender.name == 'initSafeWeight'"
              v-model="row[item.field]"
              @change="handleChangeInitSafeWeight(row, row[item.filed])"
            ></el-input-number>
            <!-- 规格型号 -->
            <!-- <el-select
              v-if="item.editRender.name == 'goodsModelId'"
              filterable
              clearable
              :disabled="isDisabled"
              v-model="row[item.field]"
              @focus="() => focusModel(row, '04')"
              @change="(val) => change(row, val, '04')"
            >
              <el-option
                v-for="(i, index) in goodsModelList"
                :key="index"
                :label="i.name"
                :value="Number(i.id)"
              ></el-option>
            </el-select> -->
            <!-- 产地 -->
            <!-- <el-select
              v-if="item.editRender.name == 'goodsPlaceId'"
              filterable
              clearable
              :disabled="isDisabled"
              v-model="row[item.field]"
              @focus="() => focusPlace(row, '03')"
              @change="(val) => change(row, val, '03')"
            >
              <el-option
                v-for="(i, index) in goodsPlaceList"
                :key="index"
                :label="i.name"
                :value="Number(i.id)"
              ></el-option>
            </el-select> -->
            <!-- 包装 -->
            <!-- <el-select
              v-if="item.editRender.name == 'packId'"
              filterable
              clearable
              :disabled="isDisabled"
              v-model="row[item.field]"
              @focus="() => focusPack(row, '05')"
              @change="(val) => change(row, val, '05')"
            >
              <el-option
                v-for="(i, index) in packList"
                :key="index"
                :label="i.name"
                :value="Number(i.id)"
              ></el-option>
            </el-select> -->
          </template>
        </vxe-table-column>
      </vxe-grid>
      <div class="radio-group-buttons">
        <el-form ref="computeValueRef">
          <el-form-item label="是否计算货物价值">
            <div>
              <el-radio v-model="goodsValueFlag" :label="1" border>是</el-radio>
              <el-radio v-model="goodsValueFlag" :label="0" border>否</el-radio>
              <el-button
                @click="saveGoodsValue"
                v-if="goodsValueFlag == 1"
                size="small"
                type="primary"
                class="vxe-btn-primary"
                >保存货物价值</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <GoodsValueTable
        v-show="goodsValueFlag == 1"
        ref="goodsValueTableRef"
        :isDisabledGoods="isDisabledGoods"
        :tableDataList="tableData"
        :billStatus="billStatus"
      />
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  import GoodsValueTable from '../GoodsValueTable/index.vue';
  import goodsApi from '@/api/masterData/goods.js';
  import superviseBillApi from '@/api/park/superviseBill';
  export default {
    name: 'pledgeTable',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      showTableBtn: {
        type: Boolean,
        default: true,
      },
      disabledGoods: {
        type: Boolean,
        default: true,
      },
      goodsList: {
        type: String,
        default: '',
      },
      categoryList: {
        type: String,
        default: '',
      },
      billId: {
        type: String,
        default: '',
      },
      billStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        columns: [],
        goodsTypeList: [], // 货物品类
        goodsCategoryList: [], //
        goodsCategoryAll: [],
        pricingStandardList: [],
        pricingUnitList: [],
        deleteCollateralLineIds: [],
        goods: [],
        category: [],
        isDisabled: false,
        status: '',
        goodsValueFlag: 0,
        ids: [], // 被删除的数据id集合
        isDisabledGoods: false,
        initSafeWeight: 0,
        quantity: 0,
        goodsModelList: [],
        goodsPlaceList: [],
        packList: [],
      };
    },
    mounted() {
      this.status = this.$route.query?.status;
      if (this.status == 'detail' || this.status == 'approval') {
        this.isDisabled = true;
        this.isDisabledGoods = true;
      } else {
        this.isDisabled = false;
      }
      this.columns = chartColumns(this);
      this.getGoodsParentApi(); // 获取商品大类
      this.getGoodsCategoryAll(); //获取全部商品品类
      // this.queryAll();
    },
    computed: {
      tableRules() {
        const initSafeWeightValid = (rule, cellValue, callback, { row }) => {
          if (parseFloat(row['initSafeWeight']) > parseFloat(row['quantity'])) {
            callback(new Error('安全重量不能超过重量'));
          } else {
            callback();
          }
        };
        return {
          initSafeWeight: [
            { required: true, message: '安全重量必填', trigger: ['change', 'blur'] },
            { validator: initSafeWeightValid },
          ],
          quantity: [{ required: true, message: '重量/数量必填', trigger: ['change', 'blur'] }],
          goodsType: [{ required: true, message: '货物类型必填', trigger: ['change', 'blur'] }],
          measureMethod: [{ required: true, message: '计量方式必填', trigger: ['change', 'blur'] }],
        };
      },
    },
    methods: {
      // 激活下拉框的时候(04-规格，05-包装,03-产地)
      // async focusModel(row, attrType) {
      //   console.log(row, attrType);
      //   if (row.goodsCategory && row.detailProductModelIdList?.length) {
      //     this.goodsModelList = row.detailProductModelIdList;
      //   } else {
      //     this.goodsModelList = await this.queryAttr([row.goodsTypeId], attrType);
      //   }
      // },
      // async focusPack(val, attrType) {
      //   if (val.goodsCategory && val.detailProductPacksIdList?.length) {
      //     this.packList = val.detailProductPacksIdList;
      //   } else {
      //     this.packList = await this.queryAttr([val.goodsTypeId], attrType);
      //   }
      // },
      // async focusPlace(val, attrType) {
      //   if (val.goodsCategory && val.detailProductOriginalPlaceIdList?.length) {
      //     this.goodsPlaceList = val.detailProductOriginalPlaceIdList;
      //   } else {
      //     console.log(val.goodsTypeId);
      //     this.goodsPlaceList = await this.queryAttr([val.goodsTypeId], attrType);
      //   }
      // },
      // change(row, val, attrType) {
      //   if (attrType == '03') {
      //     row.goodsPlace = this.goodsPlaceList.find((item) => item.id == val)?.name;
      //   }
      //   if (attrType == '04') {
      //     row.goodsModel = this.goodsModelList.find((item) => item.id == val)?.name;
      //   }
      //   if (attrType == '05') {
      //     row.pack = this.packList.find((item) => item.id == val)?.name;
      //   }
      // },
      // async queryAttr(productId, attrType) {
      //   let res = await this.$axios.post(goodsApi.GOODS_QUERY_ATTR, {
      //     productId,
      //     attrType,
      //   });
      //   if (res.data.code === 0) {
      //     return res.data.data.records || [];
      //   } else {
      //     this.$alert(res.data.msg);
      //   }
      // },
      // 查询所有的规格、包装
      // queryAll() {
      //   this.$axios.post('/maindata/product/attr/list', { attrType: '04' }).then(({ data }) => {
      //     this.goodsModelList = data.data || [];
      //   });
      //   this.$axios.post('/maindata/product/attr/list', { attrType: '05' }).then(({ data }) => {
      //     this.packList = data.data || [];
      //   });
      //   this.$axios.post('/maindata/product/attr/list', { attrType: '03' }).then(({ data }) => {
      //     this.goodsPlaceList = data.data || [];
      //   });
      // },
      changeCargoTypeHandler(row, val) {
        const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
        console.log('rowData', rowData);
        row.goodsType = rowData.parentProductNo;
        row.goodsTypeName = rowData.productChName;
        row.goodsTypeId = rowData.id;
        console.log('rowow', row.goodsTypeId);
        row.groupCategory = rowData.groupCategory;
        row.groupCategoryName = rowData.groupCategoryName;
        row.goodsCategory = '';
        row.goodsCategoryName = '';
        row.goodsModel = '';
        row.goodsModelId = '';
        row.goodsPlace = '';
        row.goodsPlaceId = '';
        row.pack = '';
        row.packId = '';
      },
      changeCargoCategoryHandler(row, val) {
        const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
        row.goodsCategory = rowData.productDetailCode;
        console.log(rowData);
        row.goodsCategoryName = rowData.productChName;
        // 是否有规格
        row.goodsModel = rowData.detailProductModel;
        row.goodsModelId = rowData.detailProductModelId;
        row.goodsPlace = rowData.detailProductOriginalPlace;
        row.goodsPlaceId = rowData.detailProductOriginalPlaceId;
        row.pack = rowData.detailProductPack;
        row.packId = rowData.detailProductPacksId;
      },
      handleChangeQuantity(tableList) {
        console.log('this.tableList', tableList, Array.isArray(tableList));

        const $table = this.$refs.pledgeTableRef;
        let tableData = [];
        if (Array.isArray(tableList)) {
          tableData = tableList;
        } else {
          tableData = $table.getTableData().fullData;
        }

        const sumQuantity = this.sumNum(tableData, 'quantity');
        this.$emit('changeQuantity', sumQuantity);
      },
      // 选中行
      handleSelectionChange({ selection }) {
        this.selectionList = selection;
      },
      // 删除行
      deleteRowHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.handleChangeQuantity(this.tableData);
        this.selectionList = [];
      },
      // 得到表格数据
      fullTableData(tableData) {
        this.tableData = tableData;
        const quantity = tableData.map((item) => item.quantity);
        const initSafeWeight = tableData.map((item) => item.initSafeWeight);
        if (quantity.length || initSafeWeight.length) {
          this.goodsValueFlag = 1;
          console.log(this.goodsValueFlag);
        } else {
          this.goodsValueFlag = 0;
        }
      },
      // 计算和
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          count += parseFloat(item[field]);
        });
        return count;
      },
      // 表尾合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['quantity'].includes(column.property)) {
              const result = this.sumNum(data, column.property);
              if (result) {
                return result;
              }
              return null;
            }
            return null;
          }),
        ];
      },
      // 获取货物大类数据
      async getGoodsParentApi() {
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              ...item,
              value: item.parentProductNo,
              label: item.productChName,
            };
          });
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      // 获取全部货物品类
      async getGoodsCategoryAll() {
        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsCategoryAll = data.data;
        } else {
          console.error('获取货物品类数据失败');
        }
      },
      // 货物类型切换时更新级联的下拉数据
      async goodsTypeChange(row) {
        row.goodsCategory = '';
        this.updateCategory(row);
      },
      // 根据选择的货物类型更新货物品类下拉
      updateCategory(row) {
        const goodsType = row.goodsType;
        if (goodsType) {
          const productParentCode = this.goodsTypeList
            .filter((item) => goodsType.includes(item.value))
            .map((item) => item.value);
          const item = this.goodsCategoryAll.filter(
            (item) => item.productParentCode == productParentCode
          );
          if (item) {
            this.goodsCategoryList = item.map((item) => {
              return {
                ...item,
                value: item.productDetailCode,
                label: item.productChName,
              };
            });
          }
        }
      },
      // 表格行激活时处理函数
      editActivedEvent({ row }) {
        console.log(row.goodsModelId, this.goodsModelList);
        this.updateCategory(row);
      },
      // 获取验证后的表格数据
      getValidateTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.pledgeTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            if (valid) {
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                  goodsTypeName: item.goodsTypeName
                    ? item.goodsTypeName
                    : this.goodsTypeList?.find((i) => i.parentProductNo == item.goodsType)?.label,
                  groupCategory: item.groupCategory
                    ? item.groupCategory
                    : this.goodsTypeList?.find((i) => i.parentProductNo == item.goodsType)
                        ?.groupCategory,
                  groupCategoryName: item.groupCategoryName
                    ? item.groupCategoryName
                    : this.goodsTypeList?.find((i) => i.parentProductNo == item.goodsType)
                        ?.groupCategoryName,
                  goodsCategoryName: item.goodsCategoryName
                    ? item.goodsCategoryName
                    : this.goodsCategoryAll?.find((i) => i.productDetailCode == item.goodsCategory)
                        ?.productChName,
                };
              });
              resolve({ tableData: formTableData, deleteCollateralLineIds: this.ids });
            } else {
              this.$message.error('请填写表格数据');
              reject({ tableData: [], deleteStorageLineIds: [] });
            }
          });
        });
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.pledgeTableRef;
        return $table.getTableData().fullData;
      },
      // 表格退出编辑
      editClosedEvent() {
        this.tableData = this.getTableData();
        this.$emit('closeEdit', this.tableData);
      },
      // 替换显示表格中value为label
      getName(type, value) {
        if (value == null) {
          return '';
        }
        let item;
        if (type == 'goodsType') {
          if (!this.goodsTypeList.length) {
            return '';
          }
          item = this.goodsTypeList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'goodsCategory') {
          if (!this.goodsCategoryAll.length || value == '') {
            return;
          } else {
            item = this.goodsCategoryAll.find((item) => item.productDetailCode == value);
            return item?.productChName;
          }
        }
        // else if (type == 'goodsModelId') {
        //   if (!this.goodsModelList.length || value == '') {
        //     return;
        //   } else {
        //     item = this.goodsModelList.find((item) => item.id == value);
        //     return item?.name;
        //   }
        // } else if (type == 'goodsPlaceId') {
        //   if (!this.goodsPlaceList.length || value == '') {
        //     return;
        //   } else {
        //     item = this.goodsPlaceList.find((item) => item.id == value);
        //     return item?.name;
        //   }
        // } else if (type == 'packId') {
        //   if (!this.packList.length || value == '') {
        //     return;
        //   } else {
        //     item = this.packList.find((item) => item.id == value);
        //     return item?.name;
        //   }
        // }
      },
      // 将数组转换为字符串
      arrayToString(array) {
        let str = '';
        array.forEach((element) => {
          str += element + ',';
        });
        str = str.substring(0, str.length - 1);
        return str;
      },
      // 保存货物价值信息
      async saveGoodsValue() {
        const postData = {
          collateralLines: [...this.tableData],
          operateFlag: 0,
          adminFlag: this.userInfo.adminFlag,
          id: this.billId,
          billStatus: this.billStatus,
        };
        console.log(postData, 'postData');
        if (!postData) return;
        this.loading = true;
        const {
          data: { code },
        } = await this.$axios.post(superviseBillApi.SAVE_BILL, {
          ...postData,
        });
        this.loading = false;
        if (code === 0) {
          this.$message.success('保存货物价值成功！');
        } else {
          this.$message.error('保存货物价值失败！');
        }
      },
      handleChangeInitSafeWeight(row, filed) {
        console.log('row-filed', row, filed);
        // 实际安全重量初始值与初始安全重量一致
        if (!row.safeWeight) {
          row['safeWeight'] = row['initSafeWeight'];
        }
      },
    },
    components: {
      GoodsValueTable,
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && val.length && Array.isArray(val)) {
            val = val.map((item) => {
              return {
                ...item,
                goodsTypeId: this.goodsTypeList.find(
                  (item1) => item1.parentProductNo == item.goodsType
                )?.id,
              };
            });
            this.fullTableData(val);
            val.forEach((item) => {
              this.goods.push(item.goodsType);
            });
          }
        },
        immediate: true,
      },
      disabledGoods: {
        handler(val) {
          this.isDisabledGoods = val;
        },
        immediate: true,
      },
      goodsList: {
        handler(val) {
          if (val !== '') {
            this.goods = val.split(',');
          } else {
            this.goods = [];
          }
          this.category = [];
          this.tableData = [];
          if (this.goods.length) {
            this.goods.forEach((item) => {
              this.tableData.push({
                goodsType: item,
                goodsTypeId: this.goodsTypeList.find((item1) => item1.parentProductNo == item)?.id,
              });
            });
            console.log(this.tableData);
          } else {
            this.tableData = [];
          }
        },
      },
      categoryList: {
        handler(val) {
          if (val !== '') {
            this.category = val.split(',');
          } else {
            this.category = [];
          }
          this.tableData = [];
          if (this.goods.length !== 0) {
            if (this.category.length !== 0) {
              this.category.forEach((item) => {
                this.goodsCategoryAll.forEach((item1) => {
                  if (item1.productDetailCode == item) {
                    console.log(item1, item, '货物品类发生变化');
                    this.tableData.push({
                      goodsType: item1.productParentCode,
                      goodsCategory: item,
                      goodsPlace: item1.detailProductOriginalPlace || '',
                      goodsPlaceId: item1.detailProductOriginalPlaceId || '',
                      goodsModel: item1.detailProductModel || '',
                      goodsModelId: item1.detailProductModelId || '',
                      pack: item1.detailProductPack || '',
                      packId: item1.detailProductPacksId || '',
                    });
                  }
                });
              });
            } else {
              this.goods.forEach((item) => {
                this.tableData.push({
                  goodsType: item,
                });
              });
            }
            let copyList = [...this.goods];
            this.tableData.forEach((item) => {
              copyList.forEach((item1) => {
                if (item.goodsType == item1) {
                  copyList.splice(copyList.indexOf(item.goodsType), 1);
                }
              });
            });
            copyList.forEach((item) => {
              this.tableData.push({
                goodsType: item,
              });
            });
          } else {
            this.tableData = [];
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
    .radio-group-buttons {
      margin-top: 10px;
    }
  }
</style>
